<template>
  <footer v-if="enable_footer" class="px-4 pb-4 bg-white sm:px-6">
    <hr class="my-6 border-gray-300 sm:mx-auto" />
    <div class="md:flex md:justify-between">
      <div class="mb-6 md:mb-0">
        <a
          :href="$TWORK_INFO.url?.homepage || '#'"
          target="_blank"
          class="flex items-center"
        >
          <img
            v-if="eventType.images.logo"
            :src="eventType.images.logo.big"
            alt="Logo"
            class="mr-4 h-14 footer-logo"
          />
          <span v-else class="text-xl font-semibold whitespace-nowrap">{{
            eventType.name
          }}</span>
        </a>
      </div>
      <div class="grid grid-cols-2 gap-8 sm:gap-6">
        <!-- Show account links when the user is not logged in -->
        <div v-if="!isLoggedIn">
          <h3 class="mb-3 text-sm font-semibold text-gray-900 uppercase">
            {{ $translate("User Account") }}
          </h3>
          <ul>
            <li class="mb-4">
              <router-link
                :to="{ path: `/${$systemPath('login')}` }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Login") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{ path: `/${$systemPath('register')}` }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Register") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{ path: `/${$systemPath('forgotPassword')}` }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Password Recovery") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div v-if="isLoggedIn">
          <h3 class="mb-3 text-sm font-semibold text-gray-900 uppercase">
            {{ $translate("Account Settings") }}
          </h3>
          <ul>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'UserAccount',
                  params: { id: $systemPath('settings') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Settings") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'UserAccount',
                  params: { id: $systemPath('payments') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Payments & Invoices") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'UserAccount',
                  params: { id: $systemPath('billingAddress') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Billing Address") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'UserAccount',
                  params: { id: $systemPath('preferences') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Preferences") }}
              </router-link>
            </li>
          </ul>
        </div>

        <div v-if="enable_legalpages">
          <h3 class="mb-3 text-sm font-semibold text-gray-900 uppercase">
            {{ $translate("Legal information") }}
          </h3>
          <ul>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'LegalPages',
                  params: { id: $systemPath('terms') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Terms & Conditions") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'LegalPages',
                  params: { id: $systemPath('privacy') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Privacy Policy") }}
              </router-link>
            </li>
            <li class="mb-4">
              <router-link
                :to="{
                  name: 'LegalPages',
                  params: { id: $systemPath('cookiePolicy') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("Cookies Policy") }}
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'LegalPages',
                  params: { id: $systemPath('contact') },
                }"
                class="text-gray-600 hover:underline"
              >
                {{ $translate("contact_us") }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-4 border-gray-300 sm:mx-auto dark:border-gray-300" />
    <div class="sm:flex sm:items-center sm:justify-between">
      <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400"
        >&copy; {{ new Date().getFullYear() }} {{ $TWORK_INFO.name }}.
        {{ $translate("All Rights Reserved") }}.</span
      >
      <div class="url-socials flex space-x-6 sm:justify-center">
        <a
          v-if="$TWORK_INFO.url.social.facebook"
          :href="$TWORK_INFO.url.social.facebook"
          target="_blank"
          class="text-gray-500 hover:text-gray-700"
        >
          <font-awesome-icon :icon="['fab', 'facebook']" class="w-5 h-5" />
        </a>
        <a
          v-if="$TWORK_INFO.url.social.twitter"
          :href="$TWORK_INFO.url.social.twitter"
          target="_blank"
          class="text-gray-500 hover:text-gray-700"
        >
          <font-awesome-icon :icon="['fab', 'twitter']" class="w-5 h-5" />
        </a>
        <a
          v-if="$TWORK_INFO.url.social.linkedin"
          :href="$TWORK_INFO.url.social.linkedin"
          class="text-gray-500 hover:text-gray-700"
        >
          <font-awesome-icon :icon="['fab', 'linkedin']" class="w-5 h-5" />
        </a>
        <a
          v-if="$TWORK_INFO.url.social.youtube"
          :href="$TWORK_INFO.url.social.youtube"
          target="_blank"
          class="text-gray-500 hover:text-gray-700"
        >
          <font-awesome-icon :icon="['fab', 'youtube']" class="w-5 h-5" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { getUserData } from "@/utils/cookie";
import { ref } from "vue";

export default {
  name: "FooterModule",
  props: {
    isSidebarOpen: {
      type: Boolean,
      default: false,
      required: false,
    },
    eventType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoggedIn: false,
    };
  },
  setup() {
    const goToAccountSettings = () => {
      this.$router.push({ path: `/${this.$systemPath("accountSettings")}` });
    };
    const enable_legalpages = ref(
      window.vueAppConfig?.settings?.enable_legalpages || false
    );
    const enable_footer = ref(
      window.vueAppConfig?.settings?.enable_footer || false
    );

    return {
      goToAccountSettings,
      enable_legalpages,
      enable_footer,
    };
  },
  mounted() {
    const user = getUserData();
    if (user && user.type === "partner") {
      this.isLoggedIn = true;
      this.user = user;
    }
  },
};
</script>


<style scoped>
.event-content {
  padding: 2rem 3rem 2rem 1.5rem;
  overflow-y: auto;
}

@media (max-width: 639px) {
  .url-socials {
    margin-top: 1rem;
  }
}
</style>